import { render, staticRenderFns } from "./AddEditLinkInvitation.vue?vue&type=template&id=6888772f"
import script from "./AddEditLinkInvitation.vue?vue&type=script&lang=js"
export * from "./AddEditLinkInvitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports